enum LoginStatusCode {
  invalidLoginOrPassword = 330,
  successed = 200,
}

export default LoginStatusCode;
